import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  IconButton,
  Stack
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem('cookieConsent');
    if (!hasConsented) {
      // Show banner after a small delay to avoid blocking initial page load
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    
    // Enable Google Analytics if it was disabled
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted'
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
    
    // Disable Google Analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied'
      });
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    // Don't set consent preference, show again on next visit
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        p: 2
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 3,
          backgroundColor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.primary' }}>
              <strong>Cookie Notice:</strong> We use cookies to improve your experience and analyze website traffic. 
              By clicking "Accept", you consent to our use of cookies for analytics purposes.{' '}
              <Typography 
                component="span" 
                variant="body2" 
                sx={{ 
                  color: 'primary.main', 
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={() => window.open('/privacy-policy', '_blank')}
              >
                Learn more
              </Typography>
            </Typography>
            
            <Stack direction="row" spacing={2} sx={{ flexWrap: 'wrap', gap: 1 }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={handleAccept}
                sx={{ minWidth: '80px' }}
              >
                Accept
              </Button>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={handleDecline}
                sx={{ minWidth: '80px' }}
              >
                Decline
              </Button>
            </Stack>
          </Box>
          
          <IconButton
            size="small"
            onClick={handleDismiss}
            sx={{ color: 'text.secondary' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Paper>
    </Box>
  );
};

export default CookieConsent;